// extracted by mini-css-extract-plugin
export default {"Button":"ShareButton_Button__9gl52"};